import React from 'react';
import { format } from 'date-fns';

import { RelativeTime } from '@zapier/date';
import { TooltipWrapper } from '@zapier/design-system';

type Props = {
  date: Date;
};

function DateToNowWithTooltip({ date }: Props) {
  return (
    <TooltipWrapper content={<span>{format(date, 'MM/dd/yyyy')}</span>}>
      {() => <RelativeTime date={date} />}
    </TooltipWrapper>
  );
}

export default DateToNowWithTooltip;
